import { EditOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Flex, Space, Table, Typography, type TableColumnsType } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomDashboard } from 'src/interfaces/entities/custom-dashboard';
import { useGetCustomDashboardsQuery } from 'src/redux/services/centralApi';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import dayjs from 'dayjs';
import AddCustomDashboard from 'src/pages/indicators/ListIndicatorsPage/_components/AddCustomDashboard';
import DeleteCustomDashboard from 'src/pages/indicators/ListIndicatorsPage/_components/DeleteCustomDashboard';

export default function ListIndicatorsPage() {
	const {
		data: customDashboardData,
		isLoading: isLoadingCustomDashboards,
		isFetching: isFetchingCustomDashboards,
		refetch: refetchCustomDashboards,
	} = useGetCustomDashboardsQuery();

	const navigate = useNavigate();

	const columns = React.useMemo<TableColumnsType<CustomDashboard>>(
		() => [
			{
				dataIndex: 'name',
				title: 'Nome',
				key: 'name',
			},
			{
				dataIndex: 'dashboard_url',
				title: 'URL de Visualização',
				key: 'dashboard_url',
				render: (value: string) => (
					<Typography.Text
						ellipsis
						style={{ display: 'flex', maxWidth: 150, }}
						copyable
					>
						{process.env.REACT_APP_PUBLIC_URL + value}
					</Typography.Text>
				),
			},
			{
				dataIndex: 'roles',
				title: 'Qtde. de Permissões',
				key: 'roles',
				width: 100,
				render: (value: { roles: string[] }) => value?.roles.length ?? 0,
			},
			{
				dataIndex: 'creation_date',
				title: 'Data de criação',
				key: 'creation_date',
				render: (value: string) =>
					dayjs(value).format('DD/MM/YYYY'),
			},
			{
				title: 'Ações',
				key: 'actions',
				render: (_, record) => (
					<Space>
						<Button
							type="text"
							icon={<EditOutlined />}
							onClick={() => navigate(`/indicadores/edit/${record.dashboard_id}`)}
						/>
						<DeleteCustomDashboard id={record.dashboard_id} />
					</Space>
				),
			},
		],
		[ navigate, ]
	);

	return (
		<DashboardTemplate pageTitle='Indicadores Personalizados'>
			<Flex style={{ padding: 5, marginBottom: 8, }} gap={8} justify='end'>
				<AddCustomDashboard />
				<Button
					type='text'
					onClick={refetchCustomDashboards}
					icon={<ReloadOutlined />}
				/>
			</Flex>
			<Table<CustomDashboard>
				columns={columns}
				dataSource={customDashboardData ?? []}
				rowKey="dashboard_id"
				loading={isLoadingCustomDashboards || isFetchingCustomDashboards}
				size="small"
			/>
		</DashboardTemplate>
	);
}
